import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type FreelancerSkill = Database['public']['Tables']['freelancer_skills']['Row'];
type FreelancerSkillInsert = Database['public']['Tables']['freelancer_skills']['Insert'];
type FreelancerSkillUpdate = Database['public']['Tables']['freelancer_skills']['Update'];

export const freelancerSkillService = {
  /**
   * Get all freelancer skills
   */
  getSkills: (includeInactive?: boolean): Promise<FreelancerSkill[]> => 
    apiClient.get<FreelancerSkill[]>('/freelancer-skills', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    }) as unknown as Promise<FreelancerSkill[]>,
  
  /**
   * Get a single freelancer skill
   */
  getSkill: (skillId: string): Promise<FreelancerSkill> => 
    apiClient.get<FreelancerSkill>(`/freelancer-skills/${skillId}`) as unknown as Promise<FreelancerSkill>,
  
  /**
   * Create a new freelancer skill (admin only)
   */
  createSkill: (skill: FreelancerSkillInsert): Promise<FreelancerSkill> => 
    apiClient.post<FreelancerSkill>('/freelancer-skills', skill) as unknown as Promise<FreelancerSkill>,
  
  /**
   * Update a freelancer skill (admin only)
   */
  updateSkill: (skillId: string, updates: FreelancerSkillUpdate): Promise<FreelancerSkill> => 
    apiClient.patch<FreelancerSkill>(`/freelancer-skills/${skillId}`, updates) as unknown as Promise<FreelancerSkill>,
  
  /**
   * Delete a freelancer skill (admin only)
   */
  deleteSkill: (skillId: string): Promise<void> => 
    apiClient.delete(`/freelancer-skills/${skillId}`),
  
  /**
   * Reorder freelancer skills (admin only)
   */
  reorderSkills: (skills: Array<{ id: string; display_order: number }>): Promise<void> => 
    apiClient.post('/freelancer-skills/reorder', { skills }),
};
